import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditFAQPageNew from "../../components/FAQ/AddFAQPageNew";



const EditFAQPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Faq" link2="/faq" title="Edit Faq" />

        {/* AddUserLayer */}
        <EditFAQPageNew />


      </MasterLayout>
    </>
  );
};

export default EditFAQPage;
